import { render, staticRenderFns } from "./BondGiveBackTotal.vue?vue&type=template&id=d0d8ad2c&scoped=true"
import script from "./BondGiveBackTotal.vue?vue&type=script&lang=js"
export * from "./BondGiveBackTotal.vue?vue&type=script&lang=js"
import style0 from "./BondGiveBackTotal.vue?vue&type=style&index=0&id=d0d8ad2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d8ad2c",
  null
  
)

export default component.exports